import AxiosInterceptor from "api/interceptor";
import fx from "utils/fx";

const categoryPost = new AxiosInterceptor();

export default {
  get() {
    return categoryPost.get("/p_category");
  },
  getCat(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return categoryPost.get("/p_category?" + qstr);
  },
  getTreeCat(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return categoryPost.get("/p_category/tree?" + qstr);
  },
  delete(id) {
    return categoryPost.delete("/p_category/" + id + "/delete");
  },
  create(inputs) {
    return categoryPost.post("/p_category", inputs);
  },
  find(id) {
    return categoryPost.get("/p_category/" + id);
  },
  update(id, inputs) {
    return categoryPost.put("/p_category/" + id + "/update", inputs);
  },
  sort(inputs) {
    return categoryPost.post("/p_category/sort", inputs);
  },
  addPost(inputs) {
    return categoryPost.post("/p_category/add-post", inputs);
  },
  removePost(inputs) {
    return categoryPost.post("/p_category/remove-post", inputs);
  },
};
